import SvgCached from '@hc-frontend/core-icons/kit/cached';
import SwapHoriz from '@hc-frontend/core-icons/kit/swap-horiz';

import ReconnectionDisclaimer from '../call-status-reconnection-disclaimer/reconnection-disclaimer';

export default function CallReconnect({
  reconnect,
  connectToSomeoneElse,
  formattedPhoneNumber,
}: {
  reconnect: () => void;
  connectToSomeoneElse: () => void;
  formattedPhoneNumber: string;
}) {
  return (
    <div>
      <div>
        <div>
          <span className={`font-bold`}>
            Looks like your call ended pretty quickly!
          </span>
        </div>
        <div>
          Did you get disconnected? Would like to reconnect to the same agency,
          or perhaps speak to someone else?
        </div>
      </div>
      <div className={`mt-16-16 flex gap-8-8`}>
        <button
          onClick={() => reconnect()}
          className={`py-8-8 rounded bg-[#F5A500] text-[#FFF] w-1/2 flex items-center justify-center gap-4-4`}
        >
          <SvgCached className={`w-[22px] h-[22px]`} />
          Reconnect
        </button>
        <button
          onClick={() => connectToSomeoneElse()}
          className={`py-8-8 rounded bg-[#FFF] w-1/2 border-[1px] border-[#F5A500]  flex items-center justify-center gap-4-4`}
        >
          <SwapHoriz className={`w-[22px] h-[22px]`} />
          Connect to someone else
        </button>
      </div>
      <ReconnectionDisclaimer formattedPhoneNumber={formattedPhoneNumber} />
    </div>
  );
}
